<template>
  <div class="wrap layout">
    <div class="ms-row">
      <div class="col-xs-12 col-md-8">
        <div class="ms-row">
          <div class="col-xs-12 col-md-6">
            <img class="error-image" :src="imgPath" />
          </div>
          <div class="col-xs-12 col-md-6">
            <h2 class="error-msg">很抱歉， </h2>
            <h2 class="error-msg">您访问的页面不存在</h2>
            <button class="c-button c-button--primary back2home" @click="backToHome">回首页</button>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-md-4">
        <div class="info-box">
          <h3 class="help-hits">您是否需要帮助？</h3>
          <div class="online-consultant">
            <span class="clickable" @click="toOnlineConsultant">
              <i class="iconfont consultant_icon">&#xe665;</i>
              <span class="consultant_text">在线客服</span>
            </span>
          </div>
          <div class="working-hours">
            <p>周一至周日 9:00-23:00</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NotFoundImage from '../assets/imgs/404.png';

export default {
  name: "NotFound",
  data() {
    return {
      imgPath: NotFoundImage
    }
  },
  created() {
    this.backToHome();
  },
  methods: {
    backToHome() {
      this.$router.replace({ path: "/landing?key=campaign" });
    },
    toOnlineConsultant() {
      window.open("https://chat8.live800.com/live800/chatClient/chatbox.jsp?companyID=1441890&configID=154108&jid=5859433606&s=1", "_blank");
    }
  }
}
</script>

<style lang="scss" scoped>
  .wrap { 
    padding: 5rem 3.125rem; margin-top: 4rem;
    .error-image { display: block; width: 70%; margin: 0 auto; }
    .error-msg {
      font-size: 1rem; color: #282828; text-align: center;
      &:first-child { margin-top: 1.25rem; }
      &:last-child { margin-top: 1rem; }
    }
    .back2home { display: block; margin: 1.375rem auto 0 auto; }
    .info-box {
      margin-top: 3.125rem; padding-top: 3.125rem; border-top: 1px solid #DCDCDC;
      .help-hits { font-size: 0.875rem; color: #282828; font-weight: 700; text-align: center; }
      .online-consultant {
        display: flex; justify-content: center;
        span {
          display: flex; flex-direction: column; justify-content: flex-start; align-items: center; margin-top: 1rem; 
          .consultant_icon { font-size: 1.125rem; line-height: 1; }
          .consultant_text { font-size: 0.75rem; color: #5E5E5E; font-weight: 700; margin-top: 1rem; }
        }
      }
      .working-hours {
        margin-top: 0.625rem; font-size: 0.625rem; color: #5E5E5E;
        p { line-height: 1.625rem; text-align: center; margin-bottom: 0; }
      }
    }
  }
  @media screen and (min-width: 48em) {}
  @media screen and (min-width: 64em) {
    .wrap {
      padding: 5rem 0; margin-top: 0;
      .error-image { width: auto; }
      .error-msg {
        font-size: 1.625rem; text-align: left;
        &:first-child { margin-top: 0; }
      }
      .back2home { display: inline-block; margin: 1.25rem 0 0 0; }
      .info-box {
        margin-top: 0; padding-top: 0; border-top: none; border-left: 1px solid #DCDCDC; padding-left: 5rem;
        .help-hits { text-align: left; }
        .online-consultant {
          margin-top: 2rem; justify-content: flex-start;
          span {
            flex-direction: row; margin-top: 0;
            .consultant_icon, .consultant_text { margin-top: 0; }
            .consultant_text { margin-left: 0.625rem; line-height: 1.125rem; }
          }
        }
        .working-hours p { text-align: left; }
      }
    }
  }
  @media screen and (min-width: 75em) {}
</style>